import React from "react";
import type { ModalViewType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import type { DebugCarInfoModalType } from "../../../../../utils/modalConstants";
import Modal from "../../../../../../shared-components/css-modules/toyota/organisms/Modal";
import Text from "../../../../../../shared-components/css-modules/toyota/atoms/Text";
import styles from "../../../../../../shared-components/toyota/debug-modals/DebugModals.module.scss";
import useAphCarInfoModal from "../../../../../hooks/useAphCarInfoModal";

const RequestCarInfoModal = (props: ModalViewType<DebugCarInfoModalType>): JSX.Element => {
    const { show, close } = props;

    const { entries } = useAphCarInfoModal();

    return (
        <Modal open={show} onRequestClose={close}>
            <div className={styles["debug-modal"]}>
                <Text tag="h2" variant="apheleia-h2" spacing="spacing-3">
                    Car Info Debugger
                </Text>
                {entries.map((entry) => (
                    <div
                        key={entry.title}
                        style={{
                            marginBottom: 32,
                        }}
                    >
                        {!!(entry.title || entry.description) && (
                            <div
                                style={{
                                    marginBottom: 16,
                                }}
                            >
                                {entry.title && (
                                    <Text tag="h3" variant="apheleia-h3">
                                        {entry.title}
                                    </Text>
                                )}
                                {entry.description && <Text>{entry.description}</Text>}
                            </div>
                        )}

                        <div className={styles.table}>
                            <table>
                                <tbody>
                                    {entry.values &&
                                        entry.values.map((value, index) => {
                                            if (value === null) return null;

                                            if (value.collapsibleContent) {
                                                return (
                                                    // eslint-disable-next-line react/no-array-index-key
                                                    <tr key={`${value.label}${index}`}>
                                                        <td colSpan={2}>
                                                            <details>
                                                                <summary>{value.label}</summary>
                                                                <pre>{value.collapsibleContent}</pre>
                                                            </details>
                                                        </td>
                                                    </tr>
                                                );
                                            }

                                            return (
                                                // eslint-disable-next-line react/no-array-index-key
                                                <tr key={`${value.label}${index}`}>
                                                    {value.long ? (
                                                        <td colSpan={2}>
                                                            <div>{value.label}</div>
                                                            <div>
                                                                {value.value && typeof value.value !== "undefined"
                                                                    ? value.value
                                                                    : "n/a"}
                                                            </div>
                                                        </td>
                                                    ) : (
                                                        <>
                                                            <td>{value.label}</td>
                                                            <td>
                                                                {typeof value.value !== "undefined"
                                                                    ? String(value.value)
                                                                    : "undefined"}
                                                            </td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    );
};

export default RequestCarInfoModal;
